import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { t } from 'i18next'
import { useRecoilState } from 'recoil'
import { Button, Card, CardBody, CardFooter, Form } from 'reactstrap'
import Swal from 'sweetalert2'

import env from '../../../env/src_config'
import { headersState } from '../../../recoil/recoil'
import { axiosError } from '../../../helpers/response'
import { isNull } from '../../../izUtils'
import { transformer, linker } from '../../../helpers/fields'
import Spinner from '../../spinner/Spinner'
import { errorStatus } from '../../../helpers/response'
import DictionaryInfoButton from '../../dictionary/DictionaryInfoButton'
import { fieldsHistory } from '../../../helpers/history'

const AddUpdateManufacturer = ({getManufacturers}) => {
    const Navigate = useNavigate();
    const [headers] = useRecoilState(headersState);
    const { securitySystemId, manufacturerId } = useParams()

    const [inputs, setInputs] = useState(null)
    const [showErrors, setShowErrors] = useState(false)
    const [history, setHistory] = useState(null)

    useEffect(() => {
        if (!isNull(inputs)) setInputs(null)
        setShowErrors(false);
        updateData(false, { security_system: {value: securitySystemId} }, true);

    }, [manufacturerId]) // eslint-disable-line react-hooks/exhaustive-deps

    const updateData = ( save, passedInputs, initialLoad = false) => {
        let payload = { save };
        if (!isNull(passedInputs)) {
            // Get data from inputs
            const keys = Object.keys(passedInputs);
            payload.data = {};
            for (let i = 0; i < keys.length; i++) {
                if (!isNull(passedInputs[keys[i]].value) && passedInputs[keys[i]].value.length !== 0) {
                    payload.data[keys[i]] = passedInputs[keys[i]].value;
                } else {
                    payload.data[keys[i]] = "";
                }
            }
        }

        let method = "patch";
        if (manufacturerId === 'create') method = "post";
        axios[method](env.api + '/api/security_system/manufacturer/' + manufacturerId, payload, {headers}).then(response => {
            if (save) {
                if (!isNull(response.data.state) && response.data.state === 'success') {
                    getManufacturers() // Refresh manufacturers list

                    let title = t('securitySystems.manufacturers.update.success.title');
                    let text = t('securitySystems.manufacturers.update.success.text');
                    if (manufacturerId === 'create') {
                        title = t('securitySystems.manufacturers.create.success.title');
                        text = t('securitySystems.manufacturers.create.success.text');
                    }

                    Swal.fire({
                        title, text,
                        icon: 'success',
                        confirmButtonColor: 'var(--theme-default)',
                        confirmButtonText: t('ok'),
                    }).then(() => Navigate('/security-systems/' + securitySystemId + '/manufacturers/' + response.data.id))
                } else {
                    setShowErrors(true)
                    errorStatus(response.data, t);
                }
            }

            let transformedData = null;
            if (!isNull(response.data.data)) {
                transformedData = transformer(response.data.data);
                setInputs(transformedData);
            }

            if (initialLoad || save) {
                const historyForFields = ['title'];
                let componentHistory = fieldsHistory(historyForFields, response?.data?.history, transformedData, 'manufacturer');
                setHistory(componentHistory)
            }
        }).catch(error => {
            axiosError(error, Navigate);
        });
    }

    const textChange = (value, name) => {
        let clonedInputs = {...inputs}
        clonedInputs[name].value = value;
        updateData(false, clonedInputs, false);
    }

    // Create fields
    const mapLinker = (field) => {
        const inputlinkerFields = {
            field,
            inputs,
            showErrors,
            history,
            textHandler: (value, id) => textChange(value, id),
            selectHandler: (value, id) => textChange(value, id),
        }

        return linker(inputlinkerFields);
    }

    return (
        <Card className="ribbon-wrapper">
            <CardBody>
                <div className="ribbon ribbon-clip ribbon-primary">
                    <div className='d-flex align-items-center'>
                        {(manufacturerId === 'create') ?
                            t('securitySystems.manufacturers.create.title')
                            :
                            <>
                                {t('securitySystems.manufacturers.update.title')}
                                <DictionaryInfoButton code="security_system.manufacturer.edit.title" id="security_system.manufacturer.edit.title" />
                            </>
                        }
                    </div>
                </div>
                {isNull(inputs) ?
                    <Spinner />
                    :
                    <Form className="theme-form mb-5">
                        { ['title'].map(field => mapLinker(field)) }
                    </Form>
                }
            </CardBody>
            <CardFooter>
                <div className='text-end'>
                    <Button color="primary" className="mt-2 me-2" onClick={() => updateData(true, inputs, false)}>{(manufacturerId === 'create') ? t('add') : t('save')}</Button>
                </div>
            </CardFooter>
        </Card>
    )
}

export default AddUpdateManufacturer